import * as Cl from '@design-system/component-library';
import { type ChangeEvent, type JSX } from 'react';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  acceptQuoteModalDescription,
  requiredToProceedMsg,
  t,
  termsAndConditionsMsg,
} from '../../common/i18n/index.js';

const TERMS_PDF_URL =
  'https://static.elisa.com/v2/image/2tqybbhjs47b/7nR6wchRAcdv5uWgNYIGZG/Elisa-Oma-Laitelasku-EPP-sopimusehdot.pdf';

export const AcceptQuoteModalContentCoCo = ({
  onAcceptance,
  isTermsAccepted = false,
  showTermsRequiredError = false,
}: {
  onAcceptance: (event: ChangeEvent<HTMLInputElement>) => void;
  isTermsAccepted: boolean;
  showTermsRequiredError: boolean;
}): JSX.Element => {
  return (
    <>
      <div>{t.SYLL(acceptQuoteModalDescription)}</div>
      <div className={`${dsClass.DISPLAY_FLEX} ${dsClass.ALIGN_ITEMS_CENTER} ${dsClass.PADDING_TOP_4}`}>
        <Cl.Checkbox checked={isTermsAccepted} onChange={onAcceptance}>
          {t.M03S('Accept')}
        </Cl.Checkbox>
        <a href={TERMS_PDF_URL} target="_blank" rel="noopener noreferrer" className={dsClass.MARGIN_TOP_2}>
          {t.BCPB(termsAndConditionsMsg)}
        </a>
      </div>
      {!isTermsAccepted && showTermsRequiredError && <Cl.InputError>{t.BYFY(requiredToProceedMsg)}</Cl.InputError>}
    </>
  );
};
